// 催收业务意向标签
export default {
  zh: {
    A: '愿意还款',
    B: '不愿还款',
    C: '已经还款',
    D: '否认欠款',
    E: '需要跟进',
    F: '未接通',
    G: '语音信箱',
    H: '需要帮助'
  },
  en: {
    A: 'Willing',
    B: 'Unwilling',
    C: 'Paid',
    D: 'Denied',
    E: 'Needs Follow Up',
    F: 'No-answer',
    G: 'Voice Mail',
    H: 'Need Help'
  },
  ba: {
    A: 'Bersedia',
    B: 'Non-bersedia',
    C: 'Telah bayar',
    D: 'Menyangkal',
    E: 'Perlu ditindaklanjuti',
    F: 'Tidak tersambung',
    G: 'Kontak suara',
    H: 'Perlu dibantu'
  }
}



// WEBPACK FOOTER //
// ./src/utils/intentionTags/collectionTags.js